import { useEffect, useState } from 'react';
import { loadKitWebFonts } from '../../music24/promote/themes/kitWebFonts';

/** True once the 9 kit fonts are in the page: the canvas then draws each text in its face. */
export function useKitFontsReady(): boolean {
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    loadKitWebFonts()
      .then(() => {
        if (isCurrent) {
          setIsReady(true);
        }
      })
      .catch(console.error);
    return () => {
      isCurrent = false;
    };
  }, []);
  return isReady;
}
